// ducks-modular-redux

import { combineReducers } from 'redux';
import product from './products';
import frames from './frames';
import order from './orders';
import settings from './settings';
import search from './search';

const rootReducer = combineReducers({
  order,
  frames,
  product,
  settings,
  search
});

export default rootReducer;
